


































export default {
  props: {
    cta: {
      type: String,
      default: 'Open Modal',
      required: true
    },
    title: {
      type: String,
      required: true
    },
    table: {
      required: true
    }
  },

  data () {
    return {
      modal: false
    }
  }
}
